import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { CreditDaysArea } from "./Styles";

export default function CreditDays({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Días de credito"
            value={!value ? document.creditDays : value}
          />
        </div>
      ) : (
        <CreditDaysArea>
          <Informative
            readonly={true}
            label="Días de credito"
            value={!value ? document.creditDays : value}
          />
        </CreditDaysArea>
      )}
    </>
  );
}
